import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

interface PathSxArgs {
  isSelected: boolean;
  isInteractive: boolean;
}

export const getPathSx =
  ({ isSelected, isInteractive }: PathSxArgs) =>
  (theme: Theme): SystemStyleObject<Theme> => {
    const rmh = theme.vars!.palette.rmh;
    return {
      fill: rmh.paper["1-surface"].rest,
      stroke: rmh.border["2-dimmed"].rest,
      strokeWidth: "0.0625rem",
      strokeLinejoin: "round",
      outline: "none",

      transition: theme.transitions.create("fill", {
        duration: theme.transitions.duration.shortest,
      }),
      ...(isInteractive && {
        cursor: "pointer",
        "&:hover": { fill: rmh.paper["7-brandFaint"].hover },
        "&:focus-visible": { fill: rmh.paper["7-brandFaint"].hover },
      }),
      ...(isSelected && {
        fill: rmh.paper["5-brandFilled"].rest,
        stroke: rmh.border["5-brand"].active,
        "&:hover": { fill: rmh.paper["5-brandFilled"].rest },
      }),
    };
  };

export const outlinePathSx = (theme: Theme): SystemStyleObject<Theme> => {
  const rmh = theme.vars!.palette.rmh;
  return {
    fill: "none",
    stroke: rmh.border["2-dimmed"].rest,
    strokeWidth: "0.0625rem",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    pointerEvents: "none",
  };
};
